import { Icon, IconProps } from "@chakra-ui/react";

export default function Message(props: IconProps) {
  return (
    <Icon viewBox="0 0 12 12" fill="none" {...props}>
      <path

        d="M1.49609 8.171C1.56961 8.35646 1.58598 8.55967 1.54309 8.7545L1.01059 10.3995C0.993432 10.4829 0.997868 10.5693 1.02348 10.6506C1.04909 10.7318 1.09502 10.8051 1.15692 10.8636C1.21883 10.9221 1.29464 10.9638 1.37719 10.9848C1.45973 11.0058 1.54627 11.0053 1.62859 10.9835L3.33509 10.4845C3.51895 10.448 3.70935 10.464 3.88459 10.5305C4.95228 11.0291 6.16177 11.1346 7.29966 10.8284C8.43756 10.5221 9.43072 9.82383 10.1039 8.85668C10.7772 7.88954 11.0872 6.7157 10.9792 5.54227C10.8713 4.36884 10.3524 3.27123 9.51412 2.4431C8.67581 1.61496 7.57194 1.10952 6.39728 1.01595C5.22262 0.922377 4.05266 1.24669 3.09381 1.93167C2.13496 2.61665 1.44886 3.61827 1.15654 4.75982C0.864217 5.90137 0.984474 7.10948 1.49609 8.171Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
